orders-planner-search-tags
  .btn.btn-collapse.btn-success.btn-sm.btn-collapse(onClick="{onClickButton}")
    span.feather.icon-search
    span.feather.icon-chevron-right(if="{!opts.show}")
    span.feather.icon-chevron-down(if="{ opts.show}")
  script(type="typescript").
    this.mixin('orders.planner.search-tags');
  style(scoped).
    :scope {
      display: inline-block;
    }
    .tags-wrap {
      margin-rßight: 60px;
    }
    .tags-wrap .label {
      display: inline-block;
      padding: 7px 7px;
      margin-bottom: 1px;
    }
    .btn-collapse {
      /* position: absolute;
      right: 15px;
      top: 0; */
    }
